module.exports = __webpack_public_path__ + "static/media/9.ba7a991a.svg";